import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Rating,
  Typography,
} from "@mui/material";
import React from "react";
import "./ProductCard.css";

const ProductCard = ({ product, handleAddToCart }) => {
  return (
    <Card className="card" id={product.id}>
      <CardMedia
        sx={{ height: 140 }}
        image={product.image}
        title="green iguana"
        component="img"
      />
      <CardContent>
        <Typography gutterBottom variant="h6" component="div">
          {product.name}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          ${product.cost}          
        </Typography>
        <Rating aria-label="stars" name="read-only" value={product.rating} readOnly />
        </CardContent>
        <CardActions>
          <Button
            className="card-button"
            variant="contained"
            onClick={() => handleAddToCart()}
          >
            <AddShoppingCartIcon />
            Add To Cart
          </Button>
        </CardActions>
      
    </Card>
  );
};

export default ProductCard;
